import React from 'react';
import ColorPalette from './ColorPalette';
import { clsx } from 'clsx';

const ZoneEditor = ({ pattern, currentColors, activeZone, onZoneSelect, onColorChange }) => {
  if (!pattern) return null;

  return (
    <div className="space-y-6">
      <div className="space-y-3">
        <label className="text-sm font-semibold text-slate-900 block">
          1. Select a Zone to Color
        </label>
        <div className="flex flex-wrap gap-2">
          {pattern.zones.map((zone) => (
            <button
              key={zone.id}
              onClick={() => onZoneSelect(zone.id)}
              className={clsx(
                "px-3 py-1.5 text-xs font-medium rounded-full border transition-colors flex items-center gap-2",
                activeZone === zone.id
                  ? "bg-slate-900 text-white border-slate-900"
                  : "bg-white text-slate-700 border-slate-200 hover:border-slate-300 hover:bg-slate-50"
              )}
            >
              <span 
                className="w-3 h-3 rounded-full border border-white/20 shadow-sm" 
                style={{ backgroundColor: currentColors[zone.id] || '#fff' }}
              />
              {zone.label}
            </button>
          ))}
        </div>
      </div>

      <div className="space-y-3">
        <div className="flex items-center justify-between">
            <label className="text-sm font-semibold text-slate-900">
            2. Choose Pigment
            </label>
            {activeZone && (
                <span className="text-xs text-slate-500">
                    Editing: <span className="font-medium text-emerald-600">{pattern.zones.find(z => z.id === activeZone)?.label}</span>
                </span>
            )}
        </div>
        
        <div className="p-4 bg-white rounded-xl border border-slate-200 shadow-sm">
            <ColorPalette 
                selectedColor={currentColors[activeZone]} 
                onColorSelect={(color) => onColorChange(activeZone, color)} 
            />
        </div>
      </div>
    </div>
  );
};

export default ZoneEditor;